export default __webpack_public_path__ + "public/images/services/Mortgage.png?4dba1595";